import ILoanPaymentAba from './ILoanPaymentAba';
import ILoanPaymentAbaHistory from './ILoanPaymentAbaHistory';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseLoanPaymentAba(raw: any): ILoanPaymentAba {
    return {
        createdTime: raw.createdTime,
        transactionAmountTotal: raw.transactionAmountTotal,
        transactionCount: raw.transactionCount,
        uuid: raw.uuid,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseLoanPaymentAbaHistory(raw: any): ILoanPaymentAbaHistory {
    return {
        createdTime: raw.createdTime,
        description: raw.description,
        uuid: raw.uuid,
    };
}
